import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BMenu',
  props: {
    matchContentWidth: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: null
    },
    width: {
      type: Number,
      default: 0
    }
  },
  emits: ['selectedItem'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var root = ref();
    function itemSelected(id) {
      emit('selectedItem', id);
    }
    expose({
      $el: root
    });
    return {
      __sfc: true,
      emit: emit,
      root: root,
      itemSelected: itemSelected
    };
  }
});